import withPrivateRoute from '@/components/hoc/withPrivateRoute';
import { ROLES_PERMISSIONS } from '@/constants';
import { QueryParamsProvider } from '@/contexts/query-params/QueryParamsProvider';
import ApprovalPage from './ApprovalPage';

const DEFAULT_PARAMS = { offset: 1, limit: 10 };

function PrivateApproval() {
  return (
    <QueryParamsProvider defaultParams={DEFAULT_PARAMS}>
      <ApprovalPage />
    </QueryParamsProvider>
  );
}

const Approval = withPrivateRoute(
  PrivateApproval,
  ROLES_PERMISSIONS.TIME_TRACKING.VIEW
);

export default Approval;
